module.exports = __webpack_public_path__ + "static/media/LOADER_v13.f4840d49.gif";